import React, { memo, useCallback } from 'react'

const ImageViewMenu = memo(({ className = '', loading = false, handleImageDownload, handleUrlCopy }) => {
  const copyClick = useCallback(
    (e) => {
      e.stopPropagation()
      handleUrlCopy(e)
    },
    [handleUrlCopy]
  )

  const downloadClick = useCallback(
    (e) => {
      e.stopPropagation()
      handleImageDownload(e)
    },
    [handleImageDownload]
  )

  return (
    <div
      className={`image-menu flex flex-row transition-none duration-[300ms] ease-in right-1/2 left-1/2 rounded-full absolute -translate-x-1/2 md:flex justify-center py-[6px] px-[12px] md:py-2 md:px-5 md:gap-2 gap-3 bg-[#000] opacity-60 text-white min-w-max z-10 ${className}`}
    >
      <div
        className={`md:py-1 md:px-1 cursor-pointer flex justify-center items-center gap-2 rounded-none text-white font-medium ${loading ? 'cursor-none opacity-60 pointer-events-none' : ''}`}
        onClick={copyClick}
      >
        <img
          className="!w-[14px] !h-[14px] md:!w-4 md:!h-4 object-contain invert"
          src={'/assets/common/copy.svg'}
          alt="copy"
          width={16}
          height={16}
          loading="eager"
        />
      </div>
      <div
        className={`md:py-1 md:px-1 cursor-pointer flex justify-center items-center gap-2 rounded-none text-white font-medium ${loading ? 'cursor-none opacity-60 pointer-events-none' : ''}`}
        disabled={loading}
        onClick={downloadClick}
      >
        <img
          className="!w-4 !h-4 object-contain invert"
          alt="download"
          src={'/assets/common/download-4165.svg'}
          width={16}
          height={16}
          loading="eager"
        />
      </div>
    </div>
  )
})

ImageViewMenu.displayName = 'ImageViewMenu'

export default ImageViewMenu
